import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=1775b443&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports